import { render, staticRenderFns } from "./AddNewLampiranPengawalan.vue?vue&type=template&id=50c41230&lang=pug&"
import script from "./AddNewLampiranPengawalan.vue?vue&type=script&lang=js&"
export * from "./AddNewLampiranPengawalan.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLampiranPengawalan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports